export const Divider = () => {
  return <div className='border-t-[0.05rem] border-kl-gray' />;
};
